define([
    "./monitoringDeliveryOverviewModule",
    "./monitoringDeliveryOverview.less",
    "./monitoringDeliveryOverviewController",
    "./monitoringDeliveryOverviewDetailsModal",
    "./modalSubtitles/modalSubtitles",
    "./modalSubtitles/modalSubtitles.less",
    "./attachmentViewModal/attachmentViewModal",
    "../monitorableMapView/modal/monitorableMapViewModal"
], function () {
});